export default __webpack_public_path__ + "static/media/OTHER_GENERAL_FUN.58e4de9a.svg";